import { createColorClasses } from "@/theme/colors";
import { IconProps } from "@/types/icons";
import clsx from "clsx";

export const CreditCardV2 = ({
  width = 27,
  height = 19,
  className,
  color = "primary",
  decorative = false,
  ariaLabel = "Credit card",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 27 19"
      fill="none"
      stroke="currentColor"
      strokeWidth="0.01"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M24.6667 0H2C0.895431 0 0 0.895431 0 2V16.6667C0 17.7712 0.895431 18.6667 2 18.6667H24.6667C25.7712 18.6667 26.6667 17.7712 26.6667 16.6667V2C26.6667 0.895431 25.7712 0 24.6667 0ZM1.33333 5.33333H25.3333V9.33333H1.33333V5.33333ZM24.6667 17.3333C25.0349 17.3333 25.3333 17.0349 25.3333 16.6667V10.6667H1.33333V16.6667C1.33333 17.0349 1.63181 17.3333 2 17.3333H24.6667ZM1.33333 4V2C1.33333 1.63181 1.63181 1.33333 2 1.33333H24.6667C25.0349 1.33333 25.3333 1.63181 25.3333 2V4H1.33333ZM2.66667 13.3333H8V12H2.66667V13.3333Z" fill="currentColor" />
    </svg>
  );
};


